module.exports = __webpack_public_path__ + "static/media/imgt-1.e16b2905.jpg";